import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { SlotProps } from 'app/area/codetable/item/types';
import { ButtonPrimary } from 'ui';
import { substanceCodetableIds } from 'app/area/codetable/item/constants';

interface SubstanceLinksProps {
  rootId: number;
}

export const SubstanceLinks = (props: SubstanceLinksProps & Partial<CodetableItemFormComponentProps> & SlotProps) => {
  const { rootId, sectionRef, translation } = props;

  const substanceHierarchyLink = () => navigate.toCodeList(rootId, substanceCodetableIds.hierarchy);
  const substanceCategoryLink = () => navigate.toCodeList(rootId, substanceCodetableIds.category);
  const infoText = translation.uom_sets_substance_links_info_text_1 + '\n' + translation.uom_sets_substance_links_info_text_2;

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="substance-links"
      validation={undefined}
      info={{ text: infoText, visible: true }}
      label={{ visible: true, text: translation.uom_sets_substance_links }} />
    <MainGridContainer>
      <div className="row">
        <div className="col-md-12 mb-3">
          <ButtonPrimary
            onClick={substanceHierarchyLink}>
            {translation.uom_sets_substance_hierarchy_link}
          </ButtonPrimary> <ButtonPrimary
            onClick={substanceCategoryLink}>
            {translation.uom_sets_substance_category_link}
          </ButtonPrimary>
        </div>
      </div>
    </MainGridContainer>
  </div>;
};
